export default __webpack_public_path__ + "static/media/scuba.a2bd7bfe.svg";